import { lazy } from 'react';

const RELOAD_KEY = 'chunk_reload_attempted';

function isChunkLoadError(error) {
  return (
    error?.name === 'ChunkLoadError' ||
    error?.message?.includes('Loading chunk') ||
    error?.message?.includes('Loading CSS chunk') ||
    (error?.message?.includes("Unexpected token '<'") && error?.message?.includes('chunk'))
  );
}

/**
 * Wraps React.lazy with automatic retry on chunk load failures.
 * After a deployment, cached HTML may reference stale chunk URLs.
 * This detects that scenario and reloads the page once to fetch
 * the updated index.html with correct chunk references.
 */
export default function lazyWithRetry(importFn) {
  return lazy(() =>
    importFn().catch((error) => {
      if (!isChunkLoadError(error)) {
        throw error;
      }

      const hasReloaded = sessionStorage.getItem(RELOAD_KEY);
      if (!hasReloaded) {
        sessionStorage.setItem(RELOAD_KEY, 'true');
        window.location.reload();
        return new Promise(() => {});
      }

      sessionStorage.removeItem(RELOAD_KEY);
      throw error;
    })
  );
}

export function clearChunkReloadFlag() {
  sessionStorage.removeItem(RELOAD_KEY);
}

export { isChunkLoadError };
